import React, { ChangeEvent, useEffect, useState } from "react";
import { QuestionInput } from "../../../../../__generated__/gql-types/globalTypes";
import { DeleteOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Col, Row } from "antd";
import { Field } from "formik";
import styles from "../../quizzForm.module.css";
import { UploadImageFile } from "../../../../UploadFile";

interface AnswersDiagramPartsComponentProps {
  question: QuestionInput;
  handleRemoveAnswer: () => void;
  handleAddAnswer: () => Promise<void>;
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement>,
    index?: number
  ) => void;
  urlImageAnswers: string[];
  setUrlImageAnswers: React.Dispatch<React.SetStateAction<string[]>>;
  imageAnswers: string[];
  setimageAnswers: React.Dispatch<React.SetStateAction<string[]>>;
  handleImageAnswers: (newImage: string, indexAnswer: number) => void;
}

export const AnswersDiagramPartsComponent = ({
  question,
  imageAnswers,
  urlImageAnswers,
  handleAddAnswer,
  handleRemoveAnswer,
  handleChange,
  setUrlImageAnswers,
  setimageAnswers,
  handleImageAnswers
}: AnswersDiagramPartsComponentProps) => {
  const [imagesAnswer, setImagesAnswer] = useState<{ id: string; ext: string }[]>([]);

  const sortInfo = () => {
    if (question.answers && question.answers.length > 0) {
      question.answers.map((answer, index) => {
        if (answer.image && answer.image.length > 0) {
          setImagesAnswer([
            ...imagesAnswer,
            {
              id: answer?.image?.split(".")[0],
              ext: answer?.image?.split(".")[1],
            },
          ]);
        } else {
          setImagesAnswer([
            ...imagesAnswer,
            {
              id: "",
              ext: "",
            },
          ]);
        }
      });
    }
  };

  useEffect(() => {
    sortInfo();
  }, [question]);

  const AddButton = ({ i }: { i: number }) => {
    if (question?.answers && question?.answers?.length - 1 === i) {
      return (
        <span>
          <a
            style={{ fontSize: 22, padding: 10 }}
            onClick={() => {
              handleAddAnswer();
            }}
          >
            <PlusCircleOutlined />
          </a>
        </span>
      );
    }
    return null;
  };

  const DeleteButton = ({ i }: { i: number }) => {
    if (question.answers!.length - 1 === i && i !== 0) {
      return (
        <span>
          <a
            style={{ fontSize: 22, padding: 10 }}
            onClick={() => {
              handleRemoveAnswer();
            }}
          >
            <DeleteOutlined />
          </a>
        </span>
      );
    }
    return null;
  };

  return (
    <>
      {question?.answers?.map((answer, index: number) => (
        <Col key={`${index}_${new Date()}`}>
          <Row style={{ marginLeft: 20, marginTop: 10 }}>
            <label htmlFor="steps">Respuesta #{index + 1}</label>
            <AddButton i={index} />
            <DeleteButton i={index} />
          </Row>
          <Row style={{ marginLeft: 20 }}>
            <Col span={12}>
              <Field
                id={`answers_${index}`}
                name="answer"
                type="text"
                className={styles.formFieldSelect}
                style={{ height: '32px' }}
                defaultValue={answer?.answer ?? ""}
                onChange={(event: ChangeEvent<HTMLInputElement>) => {
                  handleChange(event, index);
                }}
              />
            </Col>
          </Row>
        </Col>
      ))}
    </>
  );
};
